import { Model, ModelAttributes, model, modelConfig, reference } from "@mixitone/oom";
import { setAccountId } from "./concerns/SetAccountId";
import Account from "./Account";
import FundingScoutProspect from "./FundingScoutProspect";
import { Database } from "./database.types";

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    confidence: {
      type: "enum",
      enumType: "high" as Database["public"]["Enums"]["funding_scout_confidence"],
    },
    created_at: {
      type: "datetime",
    },
    extracted_facts: {
      type: "json",
      jsonType: null,
    },
    funding_scout_prospect_id: {
      type: "string",
    },
    is_deleted: {
      type: "boolean",
    },
    label: {
      type: "string",
    },
    updated_at: {
      type: "datetime",
    },
    url: {
      type: "string",
    },
  },
  {},
  {
    account: reference(() => Account as any, "account_id"),
    funding_scout_prospect: reference(() => FundingScoutProspect as any, "funding_scout_prospect_id"),
  },
);

interface FundingScoutProspectSource extends ModelAttributes<typeof config> {}

@setAccountId
@model("funding_scout_prospect_sources", config)
class FundingScoutProspectSource extends Model<typeof config> {}

export default FundingScoutProspectSource;
